"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
exports.default = (function (opened, closed, notFound) {
    var _a;
    var handlers = (_a = {},
        _a[constants_1.CompendaStatus.Opened] = opened,
        _a[constants_1.CompendaStatus.Closed] = closed,
        _a[constants_1.CompendaStatus.NotFound] = notFound,
        _a);
    document.addEventListener('compenda', function (event) {
        var detail = event.detail;
        handlers[detail.status]();
    });
});
